// 공통 export 유틸리티 (RecordDetail에서 추출)
export const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const base64 = reader.result.split(',')[1]
      resolve(base64)
    }
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

export const decryptBlobAndToBase64 = async (blob, rsKeyObj) => {
  const arrayBuffer = await blob.arrayBuffer()
  const bytes = new Uint8Array(arrayBuffer)

  let binaryStr = ''
  for (let i = 0; i < Math.ceil(bytes.length / 32768.0); i += 1) {
    binaryStr += String.fromCharCode.apply(
      null,
      bytes.slice(i * 32768, Math.min((i + 1) * 32768, bytes.length)),
    )
  }

  const decrypted = await rsKeyObj.decryptBytes(binaryStr)
  const decryptedBytes = new Uint8Array(decrypted.length)
  for (let i = 0; i < decrypted.length; i += 1) {
    decryptedBytes[i] = decrypted.charCodeAt(i)
  }

  const decryptedBlob = new Blob([decryptedBytes])
  return blobToBase64(decryptedBlob)
}

export const downloadFile = (content, filename, type = 'application/json') => {
  const blob = new Blob([content], { type })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
